<template>
	<svg
		id="Group_15572"
		data-name="Group 15572"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="12.614"
		height="20.815"
		viewBox="0 0 12.614 20.815"
	>
		<defs>
			<clipPath id="clip-path-MobileSVG">
				<rect id="Rectangle_5006" data-name="Rectangle 5006" width="12.614" height="20.815" fill="#5e7288" />
			</clipPath>
		</defs>
		<g id="Group_15571" data-name="Group 15571" clip-path="url(#clip-path-MobileSVG)">
			<path
				id="Path_6477"
				data-name="Path 6477"
				d="M11.41,20.815H9.52a3.1,3.1,0,0,0,3.094-3.094V3.094A3.1,3.1,0,0,0,9.52,0H3.094A3.1,3.1,0,0,0,0,3.094V17.721a3.1,3.1,0,0,0,3.094,3.094H1.318m1.147,0h7.8m1.226-3.094A1.971,1.971,0,0,1,9.52,19.69H3.094a1.971,1.971,0,0,1-1.969-1.969V16.314H11.489v1.406ZM1.125,12.939V3.094A1.971,1.971,0,0,1,3.094,1.125H9.52a1.971,1.971,0,0,1,1.969,1.969v12.1H1.125V14.064"
				fill="#5e7288"
			/>
			<path
				id="Path_6478"
				data-name="Path 6478"
				d="M98.005,301.947a.75.75,0,1,0,.75.75.751.751,0,0,0-.75-.75"
				transform="translate(-91.698 -284.695)"
				fill="#5e7288"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'MobileSVG',
};
</script>

<style scoped lang="scss"></style>
